// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_BED_CATEGORY,
	SETTING_CREATE_BED_CATEGORY_SUCCESS,
	SETTING_UPDATE_BED_CATEGORY,
	SETTING_UPDATE_BED_CATEGORY_SUCCESS,
	SETTING_LOAD_BED_CATEGORY,
	SETTING_LOAD_BED_CATEGORY_SUCCESS,
	SETTING_DELETE_BED_CATEGORY,
	SETTING_DELETE_BED_CATEGORY_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_BED,
	SETTING_LOAD_BED_SUCCESS,
	SETTING_CREATE_BED,
	SETTING_CREATE_BED_SUCCESS,
	SETTING_UPDATE_BED,
	SETTING_UPDATE_BED_SUCCESS,
	SETTING_DELETE_BED,
	SETTING_DELETE_BED_SUCCESS,

	SETTING_CREATE_ROOM,
	SETTING_CREATE_ROOM_SUCCESS,
	SETTING_UPDATE_ROOM,
	SETTING_UPDATE_ROOM_SUCCESS,
	SETTING_LOAD_ROOM,
	SETTING_LOAD_ROOM_SUCCESS,
	SETTING_LOAD_ALL_BED_MAPPING,
	SETTING_LOAD_ALL_BED_MAPPING_SUCCESS,
	SETTING_DELETE_ROOM,
	SETTING_DELETE_ROOM_SUCCESS,

	SETTING_UPDATE_ROOM_STATUS,
	SETTING_UPDATE_ROOM_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	bedCategoryLoading: false,
	bedLoading: false,
	roomLoading: false,
	allBedMappingLoading: false,
	bedCategory: [],
	optionBedCategory: [],
	bed: [],
	optionBed: [],
	room: [],
	optionRoom: [],
	AllBedMapping: [],
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_BED_CATEGORY:
			return { ...state, bedCategoryLoading: true, }
		case SETTING_LOAD_BED_CATEGORY_SUCCESS:
			return {
				...state,
				bedCategoryLoading: false,
				bedCategory: action.payload,
				optionBedCategory: action.payloadlist
			}
		case SETTING_CREATE_BED_CATEGORY:
			return { ...state, bedCategoryLoading: true }
		case SETTING_CREATE_BED_CATEGORY_SUCCESS:
			return { ...state, bedCategoryLoading: false }
		case SETTING_UPDATE_BED_CATEGORY:
			return { ...state, bedCategoryLoading: true }
		case SETTING_UPDATE_BED_CATEGORY_SUCCESS:
			return { ...state, bedCategoryLoading: false }
		case SETTING_DELETE_BED_CATEGORY:
			return { ...state, bedCategoryLoading: true }
		case SETTING_DELETE_BED_CATEGORY_SUCCESS:
			return { ...state, bedCategoryLoading: false }
		case SETTING_LOAD_BED:
			return { ...state, bedLoading: true, }
		case SETTING_LOAD_BED_SUCCESS:
			return {
				...state,
				bedLoading: false,
				bed: action.payload,
				optionBed: action.payloadlist
			}
		case SETTING_CREATE_BED:
			return { ...state, bedLoading: true }
		case SETTING_CREATE_BED_SUCCESS:
			return { ...state, bedLoading: false }
		case SETTING_UPDATE_BED:
			return { ...state, bedLoading: true }
		case SETTING_UPDATE_BED_SUCCESS:
			return { ...state, bedLoading: false }
		case SETTING_DELETE_BED:
			return { ...state, bedLoading: true }
		case SETTING_DELETE_BED_SUCCESS:
			return { ...state, bedLoading: false }
		case SETTING_LOAD_ROOM:
			return { ...state, roomLoading: true, }
		case SETTING_LOAD_ROOM_SUCCESS:
			return {
				...state,
				roomLoading: false,
				room: action.payload,
				optionRoom: action.payloadlist
			}
		case SETTING_CREATE_ROOM:
			return { ...state, roomLoading: true }
		case SETTING_CREATE_ROOM_SUCCESS:
			return { ...state, roomLoading: false }
		case SETTING_UPDATE_ROOM:
			return { ...state, roomLoading: true }
		case SETTING_UPDATE_ROOM_SUCCESS:
			return { ...state, roomLoading: false }
		case SETTING_DELETE_ROOM:
			return { ...state, roomLoading: true }
		case SETTING_DELETE_ROOM_SUCCESS:
			return { ...state, roomLoading: false }
		case SETTING_UPDATE_ROOM_STATUS:
			return { ...state, roomLoading: true }
		case SETTING_UPDATE_ROOM_STATUS_SUCCESS:
			return { ...state, roomLoading: false }
		case SETTING_LOAD_ALL_BED_MAPPING:
			return { ...state, allBedMappingLoading: true }
		case SETTING_LOAD_ALL_BED_MAPPING_SUCCESS:
			return {
				...state,
				allBedMappingLoading: false,
				AllBedMapping: action.payload,
			}
		case LOGOUT_USER:
			return {
				...state,
				bedCategoryLoading: false,
				bedLoading: false,
				roomLoading: false,
				allBedMappingLoading: false,
				bedCategory: [],
				optionBedCategory: [],
				bed: [],
				optionBed: [],
				room: [],
				optionRoom: [],
				AllBedMapping: [],
			};

		default: return { ...state };
	}
}